import classNames from 'classnames';

import {Icon} from 'components/atoms/Media/Icon';
import * as React from 'react';

import './style.scss';

interface Props {
    id?: string;
    name: string;
    value: string;
    className?: string;
    checked?: boolean;
    disabled?: boolean;
    childActive?: boolean;
    onChange: (e: React.MouseEvent<HTMLSpanElement>) => void;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    tabIndex?: number;
    'data-test-id'?: string;
    kexbox?: boolean;
    beard?: boolean;
}

export const Checkbox: React.FunctionComponent<Props> = (props) => {
    const checkboxClassName = classNames('checkbox-old', props.className, {
        'checkbox-old--disabled': props.disabled,
        'checkbox-old--unchecked': !props.checked,
        'checkbox-old--checked': props.checked,
        'checkbox-old--parent-active': props.childActive,
        //'checkbox-old--kex': this.props.kexbox && this.props.checked,
        //'checkbox-old--beard': this.props.beard,
    });

    return (
        <>
            <span
                className={checkboxClassName}
                onClick={props.onChange}
            >
                <input
                    type="checkbox"
                    value={props.value}
                    tabIndex={props.tabIndex}
                    name={props.name}
                    onBlur={props.onBlur}
                    id={(props.id) ?
                        props.id :
                        props.name}
                        onChange={() => null}
                        checked={props.checked}
                        data-test-id={props["data-test-id"]}
                />
                <span className="checkbox-old__handle a">
                    {props.checked && !props.childActive && <Icon name="check" /> }
                    {props.childActive && <Icon name="minus" /> }
                </span>
            </span>
        </>
    )
};
